var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentFeedbackUnsuccessful(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#F66",
    strokeWidth: 2,
    d: "M1.737 1h15.23c.124 0 .282.117.843.715l4.635 4.718c.379.382.556.74.555 1.138v22.286c0 .672-.382 1.143-.737 1.143H1.737C1.382 31 1 30.53 1 29.857V2.143C1 1.47 1.382 1 1.737 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F66",
    d: "M14.25 13.246a.84.84 0 0 1 1.189 0l.055.056a.84.84 0 0 1 0 1.188l-2.13 2.13 2.13 2.13a.84.84 0 0 1 0 1.189l-.055.055a.84.84 0 0 1-1.189 0l-2.13-2.13-2.13 2.13a.84.84 0 0 1-1.102.076l-.086-.076-.056-.055a.84.84 0 0 1 0-1.189l2.13-2.13-2.13-2.13a.84.84 0 0 1 0-1.188l.056-.056a.84.84 0 0 1 1.188 0l2.13 2.13z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFeedbackUnsuccessful);
export default __webpack_public_path__ + "static/media/document-feedback-unsuccessful.230d7fdf.svg";
export { ForwardRef as ReactComponent };